import React, { useState } from 'react';
import { db } from '../OurCourses/firebase'; // Make sure you have firebase configured
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import './gstyle.css';

function ContactUs() {
  // Form data state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    phone: '',
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      // Add a new document to the 'contacts' collection
      await addDoc(collection(db, 'contacts'), {
        ...formData,
        createdAt: serverTimestamp(),
      });

      setSubmitSuccess(true);
      setFormData({
        name: '',
        email: '',
        address: '',
        phone: '',
        message: '',
      });
    } catch (error) {
      console.error('Error saving contact:', error);
      alert('There was an error submitting your form. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="container my-5">
        <h1 className="text-center mb-4">Contact Us</h1>

        <div className="mb-4">
          <h4 className="text-primary mb-3">Head Office</h4>
          <p className="mb-2">
            <strong>Address:</strong> 932 Maradana Road, Colombo 08
          </p>
          <p className="mb-2">
            <strong>Email:</strong>
            <a href="mailto:info@eyecareinstitute.lk" className="text-decoration-none text-dark">
              info@eyecareinstitute.lk
            </a>
          </p>
          <p>
            <strong>Phone:</strong> +94 112 682 277 / +94 773 440 937
          </p>
          <div className="map-container mt-4 rounded overflow-hidden">
            <iframe
              title="Location of Eye Care Institute"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.751303437473!2d79.86938077448274!3d6.920306318426057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae259744a1d7131%3A0x614fbd9988cf7417!2sEye%20Care%20Institute!5e0!3m2!1sen!2slk!4v1733109997309!5m2!1sen!2slk"
              width="100%"
              height="450"
              style={{ border: '0' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <div className="card p-4 border rounded shadow-sm bg-light">
          <h4 className="mb-3 text-primary">INQUIRY FORM</h4>
          {submitSuccess ? (
            <div className="alert alert-success">
              Thank you for your inquiry! We will get back to you soon.
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="name" className="form-label">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="address" className="form-label">Address</label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  className="form-control"
                  placeholder="Enter your address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="phone" className="form-label">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  className="form-control"
                  placeholder="Enter your phone number"
                  required
                  maxLength="10"
                  pattern="\d{10}"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  className="form-control"
                  rows="4"
                  placeholder="Write your message here"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <button 
                type="submit" 
                className="button-contactus"
                disabled={submitting}
              >
                {submitting ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}

export default ContactUs;